/** ヘッダーに並べる操作ボタンの一辺 (px)。 */
export const CARD_ACTION_SIZE = 32;
/** ヘッダーに並べる操作ボタンのアイコンの大きさ (px)。 */
export const CARD_ACTION_ICON_SIZE = 18;

/** ヘッダーのボタンの色。押せるものは明るく、押せないものは暗く沈めて見分けやすくする。 */
export function cardActionColor(disabled: boolean): string {
	return disabled ? "var(--fg-3)" : "var(--fg-1)";
}
